import { Tabs } from './Tabs';
import { Tab } from './Tab';
import { TabPanel } from './TabPanel';
import { TabList } from './TabList';

export default {
  Tabs,
  Tab,
  TabPanel,
  TabList,
};

export { Tabs, Tab, TabPanel, TabList };
